export default {
    contextMenu: {
        backgroundColor: 'white',
        borderStyle: 'solid',
        boxShadow: '10px 19px 20px rgba(0, 0, 0, 10%)',
        position: 'absolute' as 'absolute',
        zIndex: 10,
    },
    contextMenuButton: {
        border: 'none',
        display: 'block',
        padding: '0.5em',
        textAlign: 'left' as 'left',
        width: '100%',
    },
    contextMenuButtonHover: {
        backgroundColor: 'white',
    },
};
